<template>
<b-tab lazy title-item-class="mb-1">
    <template slot="title">Diagnostics Referrals</template>
    <diagnostic-referrals-base button-top small :callback="createPatientAdminDiagnostics" />
</b-tab>
</template>
<script>
import TabExtension from "../TabExtension"

import ReferralsBase from "@/core/components/lab/ReferralsBase"
import { mapActions } from "vuex"
export default TabExtension.extend({
    name: "diagnostic-referrals",
    components: {
        'diagnostic-referrals-base': ReferralsBase
    },
    methods: {
        ...mapActions('lab', ['createPatientAdminDiagnostics']),
    }
})
</script>